import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Icons } from 'src/constants/general-media';
import Responsive from '@amzn/meridian/responsive';
import useBreakpoint from '@amzn/meridian/use-breakpoint';
import { responsiveProps, WEARABLE_RESOLUTION_WIDTH } from 'src/constants/responsiveProps';
import Text from '@amzn/meridian/text';
import * as AppStrings from 'src/localization/string-ids/app-strings';
import * as AppRoutes from 'src/routing/constants/routes';
import {
    buildGetContainerDetailsInput,
    GetContainerDetailsInput,
    GetContainerMode
} from 'src/models/GetContainerDetails';
import UILoader from 'src/components/common/loader/UILoaderContainer';
import StatusAlert from 'src/components/common/status-alert/StatusAlertContainer';
import SearchInput from 'src/components/common/search-input/SearchInput';
import { PageChrome, useSetPageChrome } from 'src/components/app/page-chrome/PageChrome';
import './HomePage.scss';

// At the wearable width and below the top bar's labels push Receive past the screen's edge, so there the home page asks
// for the compact top bar, whose icons fit 230px, the WS501's width (unverified); wider screens keep the labels
const WEARABLE_CHROME: PageChrome = { compact: true };
const FULL_CHROME: PageChrome = {};

interface HomePageProps {
    accessibleTools: string[];
    warehouseId: string;
    associate: string;
    locale: string;
    fetchContainerDetails: (getContainerDetailsInput: GetContainerDetailsInput) => void;
}

const HomePage: React.FC<HomePageProps> = (props) => {
    const navigate = useNavigate();
    useSetPageChrome(useBreakpoint(`${WEARABLE_RESOLUTION_WIDTH}px`) === 'smaller' ? WEARABLE_CHROME : FULL_CHROME);

    const onSearchSubmit = async (containerId: string) => {
        if (containerId.trim()) {
            await props.fetchContainerDetails(buildGetContainerDetailsInput(containerId, props.warehouseId, props.associate,
                props.locale, GetContainerMode.SEARCH, true));
            navigate(AppRoutes.SEARCH_PAGE_ROUTE);
        }
    };

    const SEARCH = "Search";

    const shouldToolBeVisible = (toolName: string): boolean => {
        return props.accessibleTools.includes(toolName);
    };

    return (
        <Responsive query={"max-height"} props={responsiveProps}>
            {props => (
                <div className="homepage">
                    <img src={Icons.RIV_ICON_MAIN} alt="RIV main Icon" />
                    {!shouldToolBeVisible(SEARCH) ? null : (
                        <div>
                            <img src={Icons.RIV_SEARCH_GROUP_ICON} alt="RIV search group Icon" />
                            <Text type={props.titleSize} alignment="center">
                                {AppStrings.HOMEPAGE_CENTER_TEXT}
                            </Text>
                            <div className="search-field-div">
                                <SearchInput
                                    searchFieldLabel={AppStrings.HOMEPAGE_SEARCHFIELD_LABEL}
                                    searchFieldPlaceholder={AppStrings.HOMEPAGE_SEARCHFIELD_PLACEHOLDER}
                                    renderSearchButton={true}
                                    onSubmit={onSearchSubmit}
                                />
                            </div>
                            <UILoader />
                            <StatusAlert />
                        </div>
                    )}
                </div>
            )}
        </Responsive>
    );
};

export default HomePage;
